import { render, staticRenderFns } from "./TabAgentComponent.vue?vue&type=template&id=28738052"
import script from "./TabAgentComponent.vue?vue&type=script&lang=js"
export * from "./TabAgentComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports